// @flow

import React, { type Node, useEffect } from 'react';

import { type LookAndFeelRootPropsOpenedPayment } from '@tectonics/look-and-feel';
import { getMustRedirectAfterPayment, useOpenedIncomingPayment } from '@tectonics/prs/incoming-payment';
import { useEventBusSafely } from '@tectonics/public-event-bus';
import { SetInitialPaymentMethod } from '@tectonics/components';

import { PageTemplate } from '../../templates';
import lookAndFeel from '../../index';

import { ContextProvider } from './context-provider';
import { Form } from './form';
import { IofDisplay } from '../commons/iof/components';
import { ExchangeRate } from '../commons/exchange-rate/components';
import { SelectedInstalmentDisplay } from '../commons/instalments/components';
import { AvailablePaymentMethods } from './available-payment-methods';
import { TotalDisplay } from './total-display';
import { MessagesDisplay } from './messages-display';

export function OpenedPaymentPage(props: LookAndFeelRootPropsOpenedPayment): Node {

  return (
    <ContextProvider {...props}>
      <ForceRedirectFlowForMerchantsWithRedirectAfterPaymentComponent />
      <PageTemplate data-test-id="page-opened-payment">
        <AvailablePaymentMethods />
        <SetInitialPaymentMethod lookAndFeel={lookAndFeel} />
        <MessagesDisplay />
        <TotalDisplay />
        <IofDisplay />
        <SelectedInstalmentDisplay />
        <ExchangeRate />
        <Form onSubmit={props.onSubmit} />
      </PageTemplate>
    </ContextProvider>
  );
}

/**
 * @deprecated
 * Bromelia has a listener for the fatalError event that triggers the Transparent Checkout to be destroyed.<br>
 * This is a workaround for our testing Merchant and should not be used as a definitive way of forcing the
 * redirect flow for a Merchant.<br>
 * The must_redirect_after_payment is set by the `bypass_boleto_screen` payment parameter in Pay and, for Shopify
 * payments at the moment, this parameter is set only for our testing Merchant.
 */
function ForceRedirectFlowForMerchantsWithRedirectAfterPaymentComponent(): Node {
  const eventBus = useEventBusSafely();
  const incomingPayment = useOpenedIncomingPayment();
  const shouldForceRedirectFlow = getMustRedirectAfterPayment(incomingPayment);

  useEffect(() => {
    if (shouldForceRedirectFlow) {
      eventBus.trigger('fatalError:dispatch');
    }
  }, [eventBus, shouldForceRedirectFlow]);

  return null;
}
